import { GenericService } from './Generic.service';

export class StorageFilesService extends GenericService {
    readonly URI: string = '/v1/storageFiles';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    async fetchRelations() {
        return await this.get('relations');
    }
}
